import { ACTIVE, SOUND, UPDATE_BUTTON_SAVE_STATUS } from '../constants'
import { saveRule, saveRules, setGlobalAlert, updateRule } from '.'

const toggleProperty = (property, active) => (dispatch, getState) => {
    const buttonName = property === SOUND ? SOUND : active ? 'activate' : 'deactivate'
    const onSave = (result, modifiedRules, plural) => {
        if (result === 'success') {
            modifiedRules.forEach(rule => dispatch(updateRule(rule.index, { [property]: active })))
        }

        dispatch({ type: UPDATE_BUTTON_SAVE_STATUS, status: { saving: false, button: buttonName } })
        dispatch(
            setGlobalAlert(
                (result === 'success'
                    ? `Succesfully ${active ? 'activated' : 'deactivated'}`
                    : `Error ${active ? 'activating' : 'deactivating'}`) +
                    (property === SOUND ? ' sound for' : '') +
                    (plural && result === 'partial' ? ' some of' : '') +
                    ' the selected alarm rule' +
                    (plural ? 's' : ''),
                result === 'success'
            )
        )
    }

    const { selected, localRules } = getState().editorReducer
    const selectedRules = localRules.filter(r => selected.has(r.index))

    if (selectedRules.length === 1) {
        const rule = { ...selectedRules[0], [property]: active }

        dispatch({ type: UPDATE_BUTTON_SAVE_STATUS, status: { saving: true, button: buttonName } })

        if (rule.new) {
            dispatch(updateRule(rule.index, { [property]: active }))
        } else {
            dispatch(
                saveRule(rule, (result, modifiedRules) => onSave(result, modifiedRules, false), property === SOUND)
            )
        }
    } else if (selectedRules.length > 1) {
        const existingRules = selectedRules.filter(r => !r.new)
        const newRules = selectedRules.filter(r => r.new)

        const selectedUserRules = existingRules.filter(rule => !rule.global).map(r => ({ ...r, [property]: active }))
        const selectedGlobalRules = existingRules.filter(rule => rule.global).map(r => ({ ...r, [property]: active }))

        dispatch({ type: UPDATE_BUTTON_SAVE_STATUS, status: { saving: true, button: buttonName } })
        dispatch(
            saveRules(
                selectedUserRules,
                selectedGlobalRules,
                (result, modifiedRules) => {
                    if (result !== 'error') {
                        newRules.forEach(rule => updateRule(rule.index, { [property]: active }))
                    }

                    onSave(result, modifiedRules, true)
                },
                property === SOUND
            )
        )
    }
}

export const toggleActive = active => toggleProperty(ACTIVE, active)
export const toggleSound = active => toggleProperty(SOUND, active)
